import React, { useEffect, useRef, useState } from "react";
import { json, useNavigate, useParams } from "react-router-dom";
import { PaginaCarga } from "../../Componentes/Compuestos/Paginas/PaginaCarga";
import LVButtonAccion from "../../Componentes/Basicos/LVButtonAccion";
import { CheckBox, DateBox, NumberBox } from "devextreme-react";
import { VEN_Reservas_DisponibilidadPorArticulo } from "../../Componentes/Compuestos/Complejos/Operaciones/VEN_Reservas_DisponibilidadPorArticulo";
import LV_EEX_Clientes from "../../Componentes/Compuestos/Complejos/Clientes/LV_EEX_Clientes";
import ComboAbmArtArticulos_Reservables from "../../Componentes/Compuestos/Combos/ComboAbmArtArticulos_Reservables";
import { function_VEN_Reservas_Cabecera_Insertar, function_VEN_Reservas_Cabecera_Leer, function_VEN_Reservas_Generar_JSON, function_VEN_ReservasAnexo_Generar_JSON } from "neftis7_apicaller/src/funciones/VEN/Reservas/VEN_Reservas_Cabecera";
import SignatureCanvas from "react-signature-canvas";

export const VEN_Reservas_ModificacionCreacionAnexo = () => {

  let { IdReserva, Terminal } = useParams();
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false)
  const [fecha, setFecha] = useState(new Date());
  const [idCliente, setIdCliente] = useState(0);
  const [importeTotal, setImporteTotal] = useState(0);
  const [cantidad, setCantidad] = useState(1);
  const [dataArticulos, setDataArticulos] = useState([])
  const [dataDetalles, setDataDetalles] = useState([])
  const [codigoArticulo, setCodigoArticulo] = useState("")
  const [puedeGuardar, setPuedeGuardar] = useState(false)
  const [fechaReadOnly, setFechaReadOnly] = useState(false)
  const [cierreEnProceso, setCierreEnProceso] = useState(false);

  const onClickEliminarActividad = (identificador) => {
    setDataArticulos((dataArticulos) => dataArticulos.filter((articulo) => articulo.Identificador !== identificador));
    setDataDetalles((dataDetalles) => dataDetalles.filter((detalle) => detalle.Identificador !== identificador));
  };

  const onValueChangedCodigoArticulo = async (e) => {
    setCodigoArticulo(e.value)
  }

  const onValueChangedCantidad = async (e) => {
    setCantidad(e.value)
  }

  const onValueChangedFecha = async (e) => {
    setFecha(e.value)
  }

  const onClickAgregar = () => {
    try {
      if (cantidad < 1) {
        alert("La cantidad debe ser mayor a cero.");
        return;
      }

      if (!codigoArticulo || codigoArticulo === "") {
        alert("Es necesario seleccionar una actividad.");
        return;
      }

      const Agregar = async () => {
        setLoading(true)

        const dataArticulosNew = {
          CodigoCompania: localStorage.getItem("CodigoCompania"),
          CodigoArticulo: codigoArticulo,
          Cantidad: cantidad,
          Identificador: Date.now()  // <-- ID único basado en timestamp
        };

        setDataArticulos(dataArticulos => [...dataArticulos, dataArticulosNew]);

        setPuedeGuardar(true)
        setFechaReadOnly(true)
      }

      Agregar();
    } catch (error) {
      alert(error);
    } finally {
      setLoading(false)
    }
  };

  const onClickGuardar = () => {
    try {
      if (cierreEnProceso) return; // si ya está ejecutando, no hace nada
      setCierreEnProceso(true);

      if (idCliente < 1) {
        alert("El Cliente no ha sido seleccionado.");
        return;
      }

      if (!dataArticulos) {
        alert("Al menos una actividad debe ser seleccionada.");
        return;
      }

      if (dataDetalles.length !== dataArticulos.length) {
        alert("Falta completar el Horario de alguna de las actividades.");
        return;
      }

      const Guardar = async () => {
        setLoading(true)

        const jsonFinal = await function_VEN_ReservasAnexo_Generar_JSON(idCliente, importeTotal, 1,
          fecha, false, dataDetalles, [], IdReserva)

        const IdReservaAnexo = await function_VEN_Reservas_Cabecera_Insertar(jsonFinal)

        alert('Se ha creado la Reserva Nº ' + IdReservaAnexo.data.codigoGenerado)
        navigate(`/VEN_PuntoDeVenta_/${localStorage.getItem("Terminal")}/${IdReservaAnexo.data.codigoGenerado}`);
      }

      Guardar();

    } catch (error) {
      alert(error);
    } finally {
      setLoading(false)
      setCierreEnProceso(false); // Se habilita el botón de nuevo
    }
  };

  useEffect(() => {
    if (Terminal && Terminal > 0) {
      if (Terminal != localStorage.getItem("Terminal")) {
        localStorage.setItem("Terminal", Terminal);
        window.location.reload()
      }
    }

    Terminal = localStorage.getItem("Terminal");

    while (Terminal === "0" || !Terminal) {
      const nuevoTerminal = prompt("Por favor, ingrese el número de terminal:");

      if (nuevoTerminal && nuevoTerminal !== "0") {
        localStorage.setItem("Terminal", nuevoTerminal);
        Terminal = nuevoTerminal;
        window.location.reload()
      } else {
        alert("Debe ingresar un número de terminal válido para continuar.");
      }
    }
    const lecturaReserva = async () => {
      const resultReserva = await function_VEN_Reservas_Cabecera_Leer(IdReserva)
      console.log(resultReserva.data)
      if (resultReserva.data && resultReserva.data.IdReserva > 0) {
        setIdCliente(resultReserva.data.IdClienteGenerador)
        setFecha(new Date(resultReserva.data.FechaInicio))
      } else {
        alert("La Reserva no existe.")
        navigate(`/VEN_PuntoDeVenta_/${localStorage.getItem("Terminal")}`);
      }
    }

    lecturaReserva()
  }, []);

  useEffect(() => {
    setImporteTotal(dataDetalles.reduce((total, detalle) => total + (detalle.Importe * detalle.Cantidad), 0))
  }, [dataDetalles]);

  return (
    <PaginaCarga
      Titulo={"RESERVAS - TERMINAL: " + localStorage.getItem("Terminal") + " - CÓD. PERSONA: " + localStorage.getItem("IdPersona")}
    >
      <div className="LV-GroupBox-div LV-FlexContainer"
        style={{
          marginBottom: '10px',
          marginTop: '10px',
          alignItems: 'center',
          fontSize: '25px',
          fontWeight: 'bold'
        }}
      >
        {`Anexo para Reserva: ${IdReserva} con Fecha: ${new Date(fecha).toLocaleString('es-AR', {
          day: '2-digit',
          month: '2-digit',
          year: 'numeric',
          hour: '2-digit',
          minute: '2-digit',
          hour12: false
        })} Hs.`}
      </div>
      <div className="LV-GroupBox-div LV-FlexContainer"
        style={{ marginBottom: '10px', marginTop: '10px', alignItems: 'center' }}
      >
        Actividad:
        <ComboAbmArtArticulos_Reservables
          onValueChanged={onValueChangedCodigoArticulo}
          ancho={"500"}
          style={{ marginLeft: '5px', marginRight: '20px' }} />

        Cantidad:
        <NumberBox style={{ marginLeft: '5px', marginRight: '40px', width: '50px' }} value={cantidad} onValueChanged={onValueChangedCantidad} />

        <LVButtonAccion
          Texto="AGREGAR"
          Ancho={200}
          onClick={onClickAgregar}
        />
      </div>

      {dataArticulos.map((articulo, index) => (
        <VEN_Reservas_DisponibilidadPorArticulo
          key={articulo.Identificador}
          Identificador={articulo.Identificador}
          Fecha={fecha}
          CodigoArticulo={articulo.CodigoArticulo}
          Cantidad={cantidad}
          dataDetalles={dataDetalles}
          SetDataDetalles={setDataDetalles}
          onEliminar={() => onClickEliminarActividad(articulo.Identificador)}
        />
      ))}

      <div className="LV-FlexContainer"
        style={{ marginBottom: '10px', marginTop: '10px', alignItems: 'center', justifyContent: 'center', gap: '20px' }}
      >
        IMPORTE TOTAL:
        <NumberBox text="IMPORTE TOTAL: " value={importeTotal}
          readOnly={true}
          format={{
            type: 'currency',
            precision: 0, // Número de decimales
          }} />
        <LVButtonAccion
          Texto={
            cierreEnProceso
              ? "Guardando..."
              : "GUARDAR"
          }
          Disabled={cierreEnProceso}
          Ancho={200}
          onClick={onClickGuardar}
          visible={puedeGuardar}
        />
      </div>
    </PaginaCarga>
  );
}
